var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLinkedIn = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconLinkedIn",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 27.8",
  style: {
    enableBackground: "new 0 0 45.9 27.8"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0in{fill:none;stroke:#6FC9D1;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1in{fill:none;stroke:#6FC9D1;stroke-width:0.75;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0in",
  d: "M42.3,1H23l0,0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23l0,0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1in",
  d: "M13.4,20.2h3.3V8.8h-3.3V8.2h7.1v0.5h-3.3v11.5h3.3v0.5h-7.1C13.4,20.7,13.4,20.2,13.4,20.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1in",
  d: "M24.8,11.7h0.5l0.1,1.8h0.1c1.1-1.2,2.2-2.1,3.6-2.1c2.2,0,3.3,1.2,3.3,3.6v5.7h-0.6v-5.6 c0-2.1-0.8-3.2-2.7-3.2c-1.4,0-2.3,0.7-3.7,2.2v6.6h-0.6V11.7z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconLinkedIn.60f11d40.svg";
export { ForwardRef as ReactComponent };